import { v4 as uuidv4 } from "uuid";

class Trac {
  constructor(
    id = uuidv4(),
    date = Date(),
    legSoreness = 0,
    pushSoreness = 0,
    pullSoreness = 0,
    motivation = 0,
    perceivedRecovery = 0,
    sleepQualityNutrition = 0,
    technicalComfort = 0,
    client = null
  ) {
    this.id = id;
    this.date = date;
    this.legSoreness = legSoreness;
    this.pushSoreness = pushSoreness;
    this.pullSoreness = pullSoreness;
    this.motivation = motivation;
    this.perceivedRecovery = perceivedRecovery;
    this.sleepQualityNutrition = sleepQualityNutrition;
    this.technicalComfort = technicalComfort;
    this.client = client;
  }
  uploadToCloud() {
    const data = {
      date: this.date || null,
      id: this.id.toString().toLowerCase(),
      leg_soreness: this.legSoreness,
      motivation: this.motivation,
      perceived_recovery: this.perceivedRecovery,
      pull_soreness: this.pullSoreness,
      push_soreness: this.pushSoreness,
      sleep_quality_nutrition: this.sleepQualityNutrition,
      technical_comfort: this.technicalComfort,
    };
    return data;
  }
  updateTrac(tracData) {
    this.leg_soreness = tracData.leg_soreness;
    this.push_soreness = tracData.push_soreness;
    this.pull_soreness = tracData.pull_soreness;
    this.motivation = tracData.motivation;
    this.perceived_recovery = tracData.perceived_recovery;
    this.sleep_quality_nutrition = tracData.sleep_quality_nutrition;
    this.technical_comfort = tracData.technical_comfort;
  }
}
export default Trac;
